module.exports = new __parcel__URL__("major-incident.66d70237.svg").toString();